import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  sidebar: {
    background: theme.palette.background.leftMenu,
    height: '100%',
    padding: '2% 0',
  },
  logoImg: {
    width: '200px',
  },
  sideImg: {
    width: 'auto',
    height: '50%',
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  alert: {
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
  },
}));
